import {
  ADD_WORK,
  ADD_WORK_FAILURE,
  ADD_WORK_SUCCESS,
  DELETE_WORK,
  DELETE_WORK_FAILURE,
  DELETE_WORK_SUCCESS,
  EDIT_PAGE_WORK,
  EDIT_PAGE_WORK_FAILURE,
  EDIT_PAGE_WORK_SUCCESS,
  EDIT_WORK, EDIT_WORK_FAILURE, EDIT_WORK_SUCCESS,
  GET_ALL_PAGE_WORKS,
  GET_ALL_PAGE_WORKS_FAILURE,
  GET_ALL_PAGE_WORKS_SUCCESS,
  GET_WORK, GET_WORK_FAILURE, GET_WORK_SUCCESS
} from "./actionTypes";

const initialState = {
  loading: false,
  error: "",
  works: [],
  section: {},
  page : {}
};

const stores = (state = initialState, action) => {
  switch (action.type) {
    // get work  
    case GET_ALL_PAGE_WORKS:
      state = {
        ...state,
        error: "",
        loading: true,
        works: [],
        page : {}
      };
      break;

    case GET_ALL_PAGE_WORKS_SUCCESS:
      state = {
        ...state,
        error: "",
        loading: false,
        works: action.payload.page.sections,
        page : action.payload.page
      };
      break;
      case GET_ALL_PAGE_WORKS_FAILURE:
        state = {
          ...state,
          error: action.payload,
          works: [],
          loading: false,
          page : {}
        };
        break;
  
    case EDIT_PAGE_WORK:
      state = {
        ...state,
        error: "",
        loading: true
      };
      break;

    case EDIT_PAGE_WORK_SUCCESS:
      state = {
        ...state,
        error: "",
        loading: false,
        page : {
          ...state.page, title : action.payload.page.title , subTitle : action.payload.page.subTitle}
      };
      break;

    case EDIT_PAGE_WORK_FAILURE:
      state = {
        ...state,
        error: action.payload,
        loading: false
      };
      break;
   
    // get work  
    case GET_WORK:
      state = {
        ...state,
        error: "",
        loading: true,
        work: {}
      };
      break;

    case GET_WORK_SUCCESS:
      state = {
        ...state,
        error: "",
        loading: false,
        work: action.payload.section,
      };
      break;

    case GET_WORK_FAILURE:
      state = { ...state, error: action.payload, loading: false };
      break;

    // ADD work  
    case ADD_WORK:
      state = {
        ...state,
        error: "",
        loading: true,
        work: {}
      };
      break;

    case ADD_WORK_SUCCESS:
      state = {
        ...state,
        error: "",
        loading: false,
        work: {},
        works: action.payload.sections,
      };
      break;

    case ADD_WORK_FAILURE:
      state = {
        ...state,
        error: action.payload,
        loading: false
      };
      break;

    // edit work  
    case EDIT_WORK:
      state = {
        ...state,
        error: "",
        loading: true,
        work: {}
      };
      break;

    case EDIT_WORK_SUCCESS:
      state = {
        ...state,
        error: "",
        loading: false,
        work: action.payload,
      };
      break;

    case EDIT_WORK_FAILURE:
      state = { ...state, error: action.payload, loading: false };
      break;

    // DELETE work  
    case DELETE_WORK:
      state = {
        ...state,
        error: "",
        loading: true,
      };
      break;

    case DELETE_WORK_SUCCESS:
      const worksAfterDelete = [
        ...state?.works?.filter((work) => work?.slug !== action.payload.slug),
      ];
      state = {
        ...state,
        error: "",
        loading: false,
        works: worksAfterDelete,
      };
      break;

    case DELETE_WORK_FAILURE:
      state = {
        ...state,
        error: action.payload,
        loading: false
      };
      break;

    default:
      state = { ...state };
      break;
  }

  return state;
};

export default stores;
